import { GROUP_TYPE } from '@/constants/area-constants';
import { PaginationModel } from '@/models/Pagination';
import { assignUnassignOssDevices, getAccessGroupOssDevices } from '@/services/accessGroupOssDeviceService';
import { RouterRootState } from 'connected-react-router';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from "react-toastify";
import { AccessGroupCard } from '../../../components/accessGroup/AccessGroupCard';
import { AccessGroupDetails } from '../../../components/accessGroup/AccessGroupDetails';
import AccessGroupEntryActions from '../../../components/accessGroup/AccessGroupEntryActions';
import AccessGroupExitActions from '../../../components/accessGroup/AccessGroupExitActions';
import AssignedTab from '../../../components/assignWizard/AssignedTab';
import AssignModalTwo from '../../../components/assignWizard/AssignModal';
import { Button } from '../../../components/button/Button';
import Description from '../../../components/description/Description';
import { useDialog } from '../../../components/dialog/DialogContext';
import ItemContentTabTwo from '../../../components/item-content-two/item-content-tab_two';
import { Topic } from '../../../components/item-content-two/Topic';
import SimpleItemDetails from '../../../components/item-content/SimpleItemDetails';
import { ACCESS_TYPES } from '../../../constants/access-constants';
import { useLocale } from '../../../contexts/localeContext';
import { TopicContextProvider } from '../../../contexts/topic/TopicContextProvider';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { AccessGroup as AccessGroupModel } from '../../../models/AccessGroup';
import { BreadcrumbLink } from '../../../models/BreadcrumbLink';
import AccessGroupOssDeviceColumns from "../../../models/ColumnDefinitions/AccessGroupOssDeviceColumns";
import EnrolmentColumns from "../../../models/ColumnDefinitions/EnrolmentColumns";
import { ContentWrapper } from '../../../models/ContentWrapper';
import { ListQuery } from '../../../models/ListQuery';
import { Lookup } from '../../../models/Lookup';
import LookupTypes from '../../../models/LookupTypes';
import { MultiSelectOption } from '../../../models/MultiSelectOption';
import AccessGroupOssDeviceSearch from '../../../models/search/AccessGroupOssDeviceSearch';
import CategorySearch from '../../../models/search/CategorySearch';
import CompanySearch from '../../../models/search/CompanySearch';
import DepartmentSearch from '../../../models/search/DepartmentSearch';
import EnrolmentSearch from '../../../models/search/EnrolmentSearch';
import SiteSearch from '../../../models/search/SiteSearch';
import { TabSummary } from '../../../models/TabSummary';
import { hideColumns, hideLookups } from '../../../models/utilities/columnHelper';
import { getAccessGroupById, getAccessGroupsNamesWithPagination, getMasterGroupsByAccessGroupId, storeAccessGroup } from '../../../services/accessGroupService';
import { getCategoryNameWithPagination } from '../../../services/categoryService';
import { getCompanyNamesWithPagination } from '../../../services/companyService';
import { getDepartmentNamesWithPagination } from '../../../services/departmentService';
import { getEnrolments } from '../../../services/enrolmentService';
import { getOssDeviceNamesWithPagination, getOssDevices } from '../../../services/ossDeviceService';
import { getSiteNamesWithPagination } from '../../../services/siteService';
import { getErrorMessage, showError, showLoadItemError } from '../../../services/utilities/ServiceError';
import { IAppState } from '../../../store/types';
import { appendFilter } from '../../../utilities/filters';
import {COMMAND_STATE} from "@/constants/command-status.ts";
import {batchAssignUnassignMasterGroupRelationship} from "@/services/batchSaveService.ts";

const getIdFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

interface AccessGroupProps {
    accessType: GROUP_TYPE;
}

const AccessGroup: FC<AccessGroupProps> = ({ accessType }) => {
    const initialItem: AccessGroupModel = {
        id: 0,
        name: '',
        enrolments: 0,
        entryActions: 0,
        ossDevices: 0,
        site: '',
        siteId: 0,
        exitActions: 0,
        default: undefined,
        startTime: undefined,
        description: '',
        duration: undefined,
        days: '',
        dayList: undefined,
        area: '',
        accessTimePatterns: '',
        suspended: false,
        maxCapacity: 0,
        startDate: undefined,
        endDate: undefined,
        accessAreaId: 0,
        accessTimePatternId: 0,
        allowAccess: undefined,
        arming: undefined,
        disarming: undefined,
        number: undefined,
        report: undefined,
        sGroupNumber: undefined,
        ossPermLocked: false,
        ossPrivileged: false,
        agOssUnlockTime: "0",
        agOssToggle: "0",
        accessGroupExpiryReasonFlag: false
    }
    const { translate } = useLocale();
    const isAccessGroup = accessType === ACCESS_TYPES.ACCESS_GROUP;
    const isFloorGroup = accessType === ACCESS_TYPES.FLOOR_GROUP;
    const isOssGroup = accessType === ACCESS_TYPES.OSS_GROUP;
    const initialTabs: TabSummary[] = [
        ...(isAccessGroup || isFloorGroup ? [
            { label: translate.byKey(TranslationKeys.details), badge: 0, showInitial: true, isActive: true },
        ] : []),

        ...(isAccessGroup || isFloorGroup ? [
            { label: translate.byKey(isAccessGroup ? TranslationKeys.entryActions : TranslationKeys.actions), badge: 0, showInitial: true, isActive: true },
        ] : []),

        ...(isAccessGroup ? [
            { label: translate.byKey(TranslationKeys.exitActions), badge: 0, showInitial: true, isActive: true },
        ] : []),

        ...(isOssGroup ? [
            { label: translate.byKey(TranslationKeys.devices), badge: 0, showInitial: true, isActive: true },
        ] : []),

        { label: translate.byKey(TranslationKeys.members), badge: 0, showInitial: true, isActive: true },
        { label: translate.byKey(TranslationKeys.notes), badge: 0, showInitial: true, isActive: true },
    ];
    const history = useHistory();
    const pageId = useSelector((state: RouterRootState) => getIdFromPath(state.router.location.pathname));
    const site = useSelector((state: IAppState) => state.site.site);
    const [itemId, setItemId] = useState(pageId);
    const [currentItem, setCurrentItem] = useState<AccessGroupModel>(initialItem);
    const [breadcrumb, setBreadcrumb] = useState<BreadcrumbLink[]>([]);
    const [busy, setBusy] = useState(false);
    const [tabs, setTabs] = useState<TabSummary[]>(initialTabs)
    const dialog = useDialog();
    const [selectedItem, setSelectedItem] = useState<MultiSelectOption | undefined>(undefined);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [assigningType, setAssigningType] = useState<"MEMBERS" | "OSS_DEVICES">("OSS_DEVICES");
    const lookups: Lookup[] = [
        {
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        },
        {
            name: LookupTypes.company,
            values: [],
            dataMethod: getCompanyNamesWithPagination,
            searchAccessor: CompanySearch.find(item => item.accessor === "name")?.searchOnName
        },
        {
            name: LookupTypes.department,
            values: [],
            dataMethod: getDepartmentNamesWithPagination,
            searchAccessor: DepartmentSearch.find(item => item.accessor === "name")?.searchOnName
        },
        {
            name: LookupTypes.profile_id,
            values: [],
            dataMethod: getCategoryNameWithPagination,
            searchAccessor: CategorySearch.find(item => item.accessor === "name")?.searchOnName
        }
    ];
    const allItemsPath = '/access-control/enrolment/access-groups';
    const itemPath = isAccessGroup ? '/access-control/enrolment/access-group/' : isFloorGroup ? '/access-control/enrolment/floor-group/' : '/access-control/enrolment/oss-group/';

    const getAssignedItems = async (setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>, setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>, setOriginalSelectedIds: React.Dispatch<React.SetStateAction<string[]>>, setOriginalSelectedRows: React.Dispatch<React.SetStateAction<any[]>>, setBusyLoader: React.Dispatch<React.SetStateAction<boolean>>) => {
        try {
            setBusyLoader(true);
            let pageNumber = 1, pagination: PaginationModel, ids: string[] = [], rows: any[] = [];
            do {
                let response;
                if (assigningType === "MEMBERS") {
                    response = await getMasterGroupsByAccessGroupId(translate, itemId, { pageSize: 100, goToPage: pageNumber });
                }
                else {
                    response = await getOssDeviceNamesWithPagination({ filters: itemId ? appendFilter(itemId, "Access Group", "accessGroupOssDevices.accessGroup.id", []) : [], pageSize: 100, goToPage: pageNumber });
                }

                // Support both Name rows ({ value, label }) and Enrolment-style rows ({ id, name }).
                response.rows.forEach((row: any) => {
                    const rowId = row?.value ?? row?.id;
                    const rowName = row?.label ?? row?.name;
                    if (rowId !== undefined && rowId !== null) {
                        const normalizedId = rowId.toString();
                        ids.push(normalizedId);
                        rows.push({ id: normalizedId, name: rowName ?? '' });
                    }
                });
                pagination = response.pagination;
                pageNumber++;
            } while (pageNumber <= pagination.totalPages);

            setSelectedIds(ids);
            setSelectedRows(rows)
            setOriginalSelectedIds(ids);
            setOriginalSelectedRows(rows);
        } catch (error) {
            toast.warn(getErrorMessage(error));
        }
        finally {
            setBusyLoader(false);
        }
    }

    /**
    * Fetch all topics for the topic list component
    * @returns
    */
    const topic: Topic = {
        accessor: 'agName',
        allItemsPath,
        itemPath,
        title: isAccessGroup ? translate.byKey(TranslationKeys.accessGroups) : isFloorGroup ? translate.byKey(TranslationKeys.floorGroups) : translate.byKey(TranslationKeys.ossGroups),
    }

    /**
     * Fetch all the required data on a re-render
     */
    const  reloadPage = async () => {
        try {
            let newCurrentAccessGroup: any;
            if (itemId) {
                newCurrentAccessGroup = await getAccessGroupById(itemId, translate);

                setSelectedItem({label: newCurrentAccessGroup.name, value: newCurrentAccessGroup.id.toString(), isDefault: newCurrentAccessGroup.isDefault})
                setCurrentItem(newCurrentAccessGroup);
                // update the tab badge counts
                const membersIndex = isAccessGroup ? 3 : isFloorGroup ? 2 : 1;
                let updatedTabs = isOssGroup ? updateTabBadgeTotal(0, newCurrentAccessGroup?.ossDevices, initialTabs) : updateTabBadgeTotal(1, newCurrentAccessGroup?.entryActions, initialTabs);
                if (isAccessGroup) {
                    updatedTabs = updateTabBadgeTotal(2, newCurrentAccessGroup?.exitActions, updatedTabs);
                }

                updatedTabs = updateTabBadgeTotal(membersIndex, newCurrentAccessGroup?.enrolments, updatedTabs);
                setTabs(updatedTabs);
            }
            else {
                setCurrentItem(initialItem);
                setTabs(isOssGroup ? [initialTabs[2]] : [initialTabs[0]]);
            }
            setBreadcrumb([
                { value: '/access-control/enrolment', displayName: translate.byKey(TranslationKeys.enrolments) },
                { value: allItemsPath, displayName: translate.byKey(isAccessGroup ? TranslationKeys.accessGroups : isFloorGroup ? TranslationKeys.floorGroups : TranslationKeys.ossGroups) },
                { value: itemPath + `${itemId}`, displayName: `${newCurrentAccessGroup?.name ?? ''}` }
            ]);
        } catch (error) {
            showLoadItemError(error, dialog, translate, () => { history.push(allItemsPath) });
        }
    }

     /**
     * Content and descriptors for each tab
     */
    const tabContentList: ContentWrapper[] = [
        ...(isAccessGroup || isFloorGroup ? [{ content: <AccessGroupDetails /> }] : []),
        ...(isAccessGroup || isFloorGroup ? [{ content: <AccessGroupEntryActions tabs={tabs} setTabs={setTabs} itemId={itemId} siteId={currentItem?.siteId} reloadPage={reloadPage} /> }] : []),
        ...(isAccessGroup ? [{content: <AccessGroupExitActions tabs={tabs} setTabs={setTabs} itemId={itemId} siteId={currentItem?.siteId} reloadPage={reloadPage} />}] : []),

        ...(isOssGroup ? [{
            content: <AssignedTab
                key={"assignedOssDevices"}
                column={AccessGroupOssDeviceColumns}
                searchColumn={AccessGroupOssDeviceSearch}
                id={itemId+"-1"}
                dataMethod={(listParameters?: ListQuery) => getAccessGroupOssDevices(itemId, { ...listParameters, filters: listParameters?.filters })}
                lookup={lookups}
                title={translate.byKey(TranslationKeys.assignedDevices)}>
                <Button variant="submit" shape="rounded" className="py-1 px-5" onClick={() => { setAssigningType("OSS_DEVICES"); setShowAssignModal(true); }}>{translate.byKey(TranslationKeys.manage)}</Button>
            </AssignedTab>
        }] : []),
    {
        content: <AssignedTab
            key={"assignedMembers"}
            column={hideLookups(hideColumns(EnrolmentColumns, ["companyName", "deptName"]), ['name'])}
            searchColumn={EnrolmentSearch}
            id={itemId+"-2"}
            dataMethod={(listParameters?: ListQuery) => getMasterGroupsByAccessGroupId(translate, itemId, listParameters)}
            lookup={lookups}
            title={translate.byKey(TranslationKeys.assignedMembers)}>
            <Button variant="submit" shape="rounded" className="py-1 px-5" onClick={() => { setAssigningType("MEMBERS"); setShowAssignModal(true); }}>{translate.byKey(TranslationKeys.manage)}</Button>
        </AssignedTab>
    },
    {
        content: <Description title={translate.byKey(TranslationKeys.notes)} />
    }];

    /**
     * Save details when the form is submitted
     * @param values
     */
    const saveAccessGroup = (values: AccessGroupModel) => {
        setBusy(true);
        const accessGroup: AccessGroupModel = {
            ...currentItem,
            name: values.name,
            siteId: itemId ? values.siteId : site.value,
            accessTimePatternId: values.accessTimePatternId,
            accessAreaId: values.accessAreaId,
            id: +itemId,
            endDate: values.endDate,
            maxCapacity: values.maxCapacity,
            startDate: values.startDate,
            suspended: values.suspended,
            site: itemId ? values.site : site.label,
            area: values.area,
            accessTimePatterns: values.accessTimePatterns ?? currentItem?.accessTimePatterns ?? '',
            description: values.description,
            ossPrivileged: values.ossPrivileged,
            ossPermLocked: values.ossPermLocked,
            agOssUnlockTime: values.agOssUnlockTime,
            agOssToggle: values.agOssToggle,
            ...(accessType !== null && { agType: accessType }),
            accessGroupExpiryReasonFlag: values.accessGroupExpiryReasonFlag
        };
        const createNewAccessGroup = itemId ? +itemId < 0 : true;

        storeAccessGroup(accessGroup, createNewAccessGroup)
            .then(async (value: any) => {
                setItemId(value.id);
                history.push(`${itemPath}${value.id}`);
                toast.success(translate.byKey(TranslationKeys.accessGroupSaved));
                setCurrentItem(accessGroup);
            })
            .catch(failure => {
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(failure) });
            })
            .finally(() => {
                setBusy(false);
            });
    }

    useEffect(() => {
        setItemId(pageId);
    }, [pageId])

    useEffect(() => {
        reloadPage();
    }, [itemId])

    /**
     *
     * @returns Inner content block
     */
    const getTabContent = (index?: number) => {
        if (itemId && tabs[index ?? 0].isActive) {
            const selectedTabContent = tabContentList[index ?? 0];
            return selectedTabContent.content;
        }

        return isOssGroup ? tabContentList[2].content : tabContentList[0].content;
    };

    const updateTabBadgeTotal = (tabIndex: number, totalCount: number, currentTabs: TabSummary[]) => {
        const newTabs = [...currentTabs];
        newTabs[tabIndex].badge = totalCount;
        return newTabs;
    }

    const assignItems = (toBeAssigned: string[], toBeUnassigned: string[]) => {
        setBusy(true);
        const assignMethod = assigningType === "MEMBERS" ? batchAssignUnassignMasterGroupRelationship : assignUnassignOssDevices;
         assignMethod(toBeAssigned, toBeUnassigned, itemId).then((result) => {
             reloadPage();
             if (result && result.success) {
                 toast.success(translate.byKey(TranslationKeys.success));
             }
        }).catch((err) => {
            const rawMessages: string[] = err.message.split(';');
            const cleanedMessages = rawMessages.filter((msg) => msg && msg.length > 0 && msg !== ';');
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: cleanedMessages});
        }).finally(() => {
            setBusy(false);
        })
    }

    return <>
        <TopicContextProvider
            dataMethod={(listQuery?: ListQuery) => getAccessGroupsNamesWithPagination(accessType, listQuery)}
                itemId={itemId}
                topic={topic}
                selectedItem={selectedItem} >
                <ItemContentTabTwo>
                    <SimpleItemDetails
                        breadcrumb={breadcrumb}
                        busy={busy}
                        getTabContent={getTabContent}
                        itemProfile={currentItem}
                        onBack={() => history.push(allItemsPath)}
                        saveDetails={saveAccessGroup}
                        tabs={tabs}
                        itemPath={itemPath}
                        initialValues={currentItem}>
                        <AccessGroupCard agType={accessType} />
                    </SimpleItemDetails>
            </ItemContentTabTwo>
        </TopicContextProvider>
        <AssignModalTwo
            tableColumns={assigningType === "MEMBERS" ? hideLookups(hideColumns(EnrolmentColumns, ["totalTags", "category",]), ['name']) : AccessGroupOssDeviceColumns}
            assigningTitle={translate.byKey(assigningType === "MEMBERS" ? TranslationKeys.members : TranslationKeys.devices)}
            lookup={lookups}
            dataMethod={(listParameters?: ListQuery) => assigningType === "MEMBERS" ? getEnrolments(translate, listParameters) : getOssDevices(listParameters)}
            isOpen={showAssignModal}
            onClose={() => { setShowAssignModal(false) }}
            searchColumns={assigningType === "MEMBERS" ? EnrolmentSearch : AccessGroupOssDeviceSearch}
            getAssignedItems={getAssignedItems}
            handleSubmit={assignItems}
            modalTitle={translate.byKey(assigningType === "MEMBERS" ? TranslationKeys.assignMembers : TranslationKeys.assignDevices)} />
    </>
}

export default AccessGroup;

